import React from 'react'
import { Route } from 'react-router'
import Splitter from '../helpers/Splitter'

const ViewApps = Splitter(() => import('../components/app/ViewApps'))

export const appRoutes = <Route path="apps" component={ViewApps} />



// WEBPACK FOOTER //
// ./src/routes/appRoutes.js